export default function SVGMicrowave(props: any) {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="5" y="50" width="39" height="54" rx="2" transform="rotate(-90 5 50)" stroke="#757575" strokeWidth="2" />
            <path d="M51 23H45" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M51 29H45" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M36.0026 22.667H13.3359V38.667H36.0026V22.667Z" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M51.1111 39C51.1111 40.7182 49.7182 42.1111 48 42.1111C46.2818 42.1111 44.8889 40.7182 44.8889 39C44.8889 37.2818 46.2818 35.8889 48 35.8889C49.7182 35.8889 51.1111 37.2818 51.1111 39Z"
                stroke="#757575"
                strokeWidth="1.77778"
            />
            <path d="M16.002 51.5557V52.4446" stroke="#757575" strokeWidth="3.55556" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M48.002 51.5557V52.4446" stroke="#757575" strokeWidth="3.55556" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
